/**
 * Hook to hydrate interviews from database on app initialization
 * Loads interviews from PostgreSQL when project is selected
 */

import { useEffect } from 'react'
import { useInterviewerStore } from '@/stores/interviewerStore'
import { useProjectStore } from '@/stores/projectStore'

/**
 * Hydrate interviews from database when project changes
 * Call this hook in App.tsx or root component
 */
export function useInterviewHydration() {
  const currentProject = useProjectStore((state) => state.currentProject)
  const hydrateSources = useInterviewerStore((state) => state.hydrateSources)

  useEffect(() => {
    if (currentProject?.id) {
      // Load interviews from database for current project
      hydrateSources(currentProject.id)
    }
  }, [currentProject?.id, hydrateSources])
}
